import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import {
  PostTradingCompetitionRegisterationParams,
  RegisteredTradingCompetition,
  SquadCompetition,
  TradingCompetition,
  TradingCompetitionRankings,
  TradingCompetitionsParams,
} from './types';

export const fetchTradingCompetitionApi = (eventId: string) =>
  fetchClient.fetch<TradingCompetition>(`/v1/trading-competitions/${eventId}`);

export const getTradingCompetitionsListApi = (params: TradingCompetitionsParams = {}) =>
  apiClient.get<{ competitions: TradingCompetition[] }>('/v1/trading-competitions/list', { params });

export const getTradingCompetitionApi = (eventId: string) =>
  apiClient.get<TradingCompetition>(`/v1/trading-competitions/${eventId}`);

export const getTradingCompetitionRankingsApi = (eventId: string) =>
  apiClient.get<TradingCompetitionRankings>(`/v1/trading-competitions/${eventId}/rankings`);

export const getRegisteredTradingCompetitionApi = () =>
  apiClient.get<RegisteredTradingCompetition>('/v1/trading-competitions/ranking');

export const postTradingCompetitionRegisterApi = (eventId: string, data: PostTradingCompetitionRegisterationParams) =>
  apiClient.post(`/v1/trading-competitions/${eventId}/register`, data);

export const postTradingCompetitionDeregisterApi = (eventId: string) =>
  apiClient.post(`/v1/trading-competitions/${eventId}/deregister`);

export const postTradingCompetitionClaimRewardApi = (eventId: string) =>
  apiClient.post(`/v1/trading-competitions/${eventId}/claim-reward`);

export const fetchSquadCompetitionApi = (id: string) =>
  fetchClient.fetch<SquadCompetition>(`/v1/squad-competitions/${id}`);

export const getSquadCompetitionApi = (id: string) => apiClient.get<SquadCompetition>(`/v1/squad-competitions/${id}`);
